<template>
  <div>
    <transactions-table
      :state="state"
      :transactions="transactions"
      :totalTransactions="totalTransactions"
      :totalAmount="totalAmount"
      :pageSize="pageSize"
      @saved="onTransactionSaved"
      @canceled="onTransactionCanceled"
      @tableOptionUpdated="onTableOptionUpdated"
    ></transactions-table>
    <v-layout class="mb-5" align-start justify-left wrap v-if="showReport">
      <v-flex>
        <v-card>
          <v-card-title>
            <h2 v-if="totalAmount">{{totalAmount | price('INR')}}</h2>
            <v-spacer></v-spacer>
            <span v-if="totalTransactions">
              {{totalTransactions}}
              transactions
            </span>
          </v-card-title>
          <v-data-table
            :loading="isDataLoading"
            :headers="aggHeaders"
            :items="aggregation"
            :items-per-page="100"
            dense
            item-key="category.key"
          >
            <template v-slot:item.category="{ item }">
              <div>{{item.category.category.name}}</div>
            </template>
            <template v-slot:item.sum="{ item }">
              <div>{{item.sum | price('INR')}}</div>
            </template>
            <template v-slot:item.avg="{ item }">
              <div>{{item.avg | price('INR')}}</div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { DataState } from "@/state"
import { Transaction } from "@/models/transaction"
import TransactionsTable from "@/components/TransactionsTable"

export default {
  props: {
    filter: {
      type: Object
    },
    showReport: {
      type: Boolean,
      default: false
    },
    refetch: {
      type: Boolean,
      default: false
    },
  },

  components: {
    TransactionsTable
  },

  data () {
    return {
      transactions: [],
      totalTransactions: 0,
      totalAmount: 0,
      aggregation: [],
      aggHeaders: [
        { text: "Category", value: "category" },
        { text: "Total", value: "sum"},
        { text: "Count", value: "count"},
        { text: "Avg.", value: "avg"},
      ],
      state: DataState.newLoading(),
      prevQuery: '',
      currentPage: 1,
      tableOptions: {},
      pageSize: 100,
    }
  },

  computed: {
    isDataLoading () {
      return this.state && this.state.isLoading()
    }
  },

  watch: {
    filter: {
      handler () {
        console.log('Filter updatd, fetching again')
        this.fetch()
      },
      deep: true
    },
    refetch (newValue) {
      if (newValue) {
        this.prevQuery = ''
        console.log('Fetching again')
        this.fetch(false, false)
        this.$emit('update:refetch', false)
      }
    },
  },

  mounted() {
    this.onLoaded();
  },

  methods: {
    onLoaded() {
      this.fetch(true, false, {})
    },

    onTableOptionUpdated (updated) {
      this.tableOptions = updated
      this.fetch(false, true, updated)
    },

    fetch(isFirstTime, doNext) {

      // console.log(this.tableOptions.page, this.currentPage, this.tableOptions.sortBy)
      // console.log(JSON.parse(JSON.stringify(this.tableOptions)))

      let params = Object.assign({}, this.filter)
      if (this.tableOptions.page != this.currentPage && this.transactions.length) {
        let cursor = {last: this.currentPage * this.pageSize}
        if (this.tableOptions.page < this.currentPage) {
          cursor = {last: this.tableOptions.page * this.pageSize, reverse:1}
        }

        params = Object.assign(params, cursor)
      }

      if (this.tableOptions.sortBy && this.tableOptions.sortBy.length) {
        let orderby = []
        for (let i=0; i<this.tableOptions.sortBy.length; i++) {
          let opt = this.tableOptions.sortDesc[i] ? '~': ''
          orderby.push(opt + this.tableOptions.sortBy[i])
        }
        params['orderby'] = orderby
      } else {
        params['orderby'] = []
      }

      const newQuery = JSON.stringify(params)
      if (newQuery == this.prevQuery) {
        console.log('Ignoring same query')
        return 
      }

      this.currentPage = (this.tableOptions.page == undefined)? 1 : this.tableOptions.page
      this.prevQuery = newQuery
      this.state.changeToLoading()

      Transaction.list(params)
      .then(response => {
        this.transactions = response.transactions
        this.aggregation = response.aggregation
        this.totalTransactions = response.cursor.total
        this.totalAmount = response.cursor.sum
        this.state.changeToLoaded();
      })
      .catch(error => {
        this.state.changeToError(error)
      });
    },

    onTransactionSaved(transaction, gonext) {
      this.$emit('saved', transaction, gonext)
    },

    onTransactionCanceled(transaction, gonext) {
      this.$emit('canceled', transaction, gonext)
    }
  }
}
</script>
